module.exports = __webpack_public_path__ + "img/restaurant_bodyimage07.89d260de.jpg";